export var isIOS = function () {
    try {
        if (typeof window.isIOS !== "undefined")
            return window.isIOS === true;
        return !!navigator.platform && /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);
    }
    catch (error) {
        window.captureException(error);
        return false;
    }
};
